import React from "react";
import "./DayNavigation.css";
import { useModalContext } from "../../context/ModalContext";

interface Props {
  formattedDate: string;
  goToPreviousDay: () => void;
  goToNextDay: () => void;
}

const DayNavigation: React.FC<Props> = ({
  formattedDate,
  goToPreviousDay,
  goToNextDay,
}) => {
  // Example: disable buttons if any modal is open
  const {isAnyModalOpen } = useModalContext();
  const disabled = isAnyModalOpen;

  return (
    <div className="date-navigation">
      <button
        onClick={goToPreviousDay}
        className={`nav-button prev-button ${
          disabled
            ? "text-gray-400 cursor-not-allowed"
            : "text-orange-500 hover:text-orange-600"
        }`}
        aria-label="Previous day"
        disabled={disabled}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      <div className="date-display">
        <span className="date-text">{formattedDate}</span>
      </div>

      <button
        onClick={goToNextDay}
        className={`nav-button next-button ${
          disabled
            ? "text-gray-400 cursor-not-allowed"
            : "text-orange-500 hover:text-orange-600"
        }`}
        aria-label="Next day"
        disabled={disabled}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  );
};

export default DayNavigation;
